var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedirectResetPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2116_1419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9053 13.3569L15.8554 8.35682C16.0519 8.1583 16.0444 7.84177 15.8554 7.64275L10.9048 2.64264C10.7093 2.44562 10.3928 2.44562 10.1977 2.64264C10.0022 2.84017 10.0022 3.15969 10.1977 3.35722L14.2942 7.49523L0.500028 7.49523C0.223984 7.49523 -1.97032e-05 7.72127 -1.97154e-05 8.00031C-1.97276e-05 8.27934 0.224025 8.50538 0.500028 8.50538L14.2947 8.50538L10.1983 12.6434C10.0027 12.8404 10.0027 13.1604 10.1983 13.3575C10.3932 13.5545 10.7098 13.5545 10.9053 13.3569Z",
    fill: "#0F314D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2116_1419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectResetPass);
export default __webpack_public_path__ + "static/media/redirectResetPass.f3ad279d16cfb3ff72ac8078931d1d45.svg";
export { ForwardRef as ReactComponent };